import React, { useEffect, useMemo, useState } from 'react'
import CommonVideoCard from '../common-video-card'
import CommonVideoCardItem from '../common-video-card/item'
import CommonTopTextCard from '../common-top-text-card'
import FloorTabTitle from 'Components/floor/floor-tab-title'
import { sendTeaCommEvent } from 'lib/tea-analyze'
// import { Swiper, SwiperSlide } from 'swiper/react'
// import { useInView } from 'react-intersection-observer'
import {
  getHomeVideo,
  // getPGCVideoRank,
  getPGCCategoryList,
  PGC_CAGETORY_SROUCE,
  ICommonVideoData,
  ICommonContentRankItem,
  getPGCVideoRank,
} from '../../services/home'
import 'array-flat-polyfill'
import getContentJumpUrl from 'lib/get-content-jump-url'
import { ResponsiveConfig } from 'Components/new/responsive-swiper'
import AdTextLink from 'Components/ad/ad-text-link'
import BannerAdWithSource, { AdDataType } from 'Components/ad/ad-width-resource'
import useDealeradInfo from 'Components/hooks/use-dealerad-info'
import { unstable_batchedUpdates } from 'react-dom'
import useLazyRender from 'Components/hooks/use-lazy-render'
import { defaultNavList } from 'New/video/components/top-nav'
import { AD_RIT } from 'Constants/ad'

const NAV_LIST = [
  {
    label: '大神评测官',
    link: 'https://www.dongchedi.com/video/groups/128',
  },
  {
    label: '38号车评中心',
    link: 'https://www.dongchedi.com/video/groups/111',
  },
  {
    label: '明星评测官',
    link: 'https://www.dongchedi.com/video/groups/144',
  },
  {
    label: '丈母娘唠车',
    link: 'https://www.dongchedi.com/video/groups/131',
  },
]

const decoratorVideoInfo = (item: ICommonVideoData) => {
  return {
    coverUrl: item.video_info?.cover_url,
    videoDuration: item.video_info?.video_duration,
    videoWatchCount: item.video_info?.video_watch_count,
    videoSize: item.video_info?.video_size,
  }
}

const decoratorColum = (item: ICommonVideoData) => {
  return {
    id: item.column?.id,
    logo: item.column?.logo,
    name: item.column?.name,
    introduction: item.column?.introduction,
    description: item.column?.description,
    episode: item.column?.episode,
    modify_time: item.column?.modify_time,
    publish_time: item.publish_time,
  }
}

const cols: ResponsiveConfig = {
  sm: 3,
  md: 3,
  lg: 3,
  xl: 3,
  '2xl': 4,
}

const rows: ResponsiveConfig = {
  sm: 2,
  md: 2,
  lg: 2,
  xl: 2,
  '2xl': 2,
}

const renderSlider = (item: any, order: number, activeIndex: number) => {
  return (
    <CommonVideoCardItem
      order={order}
      activeIndex={activeIndex}
      itemTeaParams={{
        page_id: 'page_main_new',
        event_id: 'video_module_card_content',
        module_id: 'video_module',
      }}
      titleTeaParams={{
        page_id: 'page_main_new',
        event_id: 'video_module_card_title',
        module_id: 'video_module',
      }}
      title={item?.title}
      uniqueIdStr={item.unique_id_str}
      articleType={item?.article_type}
      videoInfo={decoratorVideoInfo(item)}
      column={decoratorColum(item)}
    />
  )
}

const pgcCategoryList = defaultNavList.filter((d) => d.showHome)

const HomeVideo: React.FC<{
  videoPGCRankData?: ICommonContentRankItem[]
  homeVideo?: ICommonVideoData[]
  pgcCategoryList?: string[]
}> = () => {
  // if (pgcCategoryList?.length > 10) {
  //   pgcCategoryList.length = 10
  // }

  const [homeVideo, setHomeVideo] = useState<ICommonVideoData[]>([])
  const [videoPGCRankData, setVideoPGCRankData] = useState<
    ICommonContentRankItem[]
  >([])
  const { dealeradInfo } = useDealeradInfo({
    ritIds: [
      AD_RIT.rit_dealer_ad_home_page_video_bottom,
      AD_RIT.rit_dealer_ad_video_rank_top,
    ].join(','),
  })

  const dealeradBannerData = useMemo(() => {
    const bannerInfo =
      dealeradInfo?.[AD_RIT.rit_dealer_ad_home_page_video_bottom]
    if (!bannerInfo) {
      return []
    }
    return [
      {
        type: 1000,
        info: { raw_spread_data: bannerInfo as unknown as AdDataType },
      },
    ]
  }, [dealeradInfo])

  useEffect(() => {
    getHomeVideo().then((res) => {
      setHomeVideo(res?.video_list || [])
    })
    getPGCVideoRank().then((res) => {
      setVideoPGCRankData(res || [])
    })
  }, [])

  return (
    <div className="home-video-card tw-grid tw-grid-cols-40 tw-gap-x-12 fix-swiper-mutil-row-mt-16 tw-mt-24">
      <div
        className="tw-col-span-30 2xl:tw-col-span-32"
        data-log-view-config={JSON.stringify({
          repeated: true,
        })}
        data-log-view={JSON.stringify({
          event: 'show_event',
          params: {
            page_id: 'page_main_new',
            event_id: 'common_conponent_module',
            module_id: 'video_module',
          },
        })}
      >
        <CommonVideoCard
          list={homeVideo || []}
          onTitleClick={() => {
            sendTeaCommEvent('clk_event', {
              page_id: 'page_main_new',
              event_id: 'video_module_title',
              module_id: 'video_module',
            })
          }}
          onNavItemClick={(item) => {
            sendTeaCommEvent('clk_event', {
              page_id: 'page_main_new',
              event_id: 'video_module_keywords',
              module_id: 'video_module',
              button_name: item.label,
            })
          }}
          titleObj={{
            link: '/video',
            label: '视频看车',
          }}
          navList={pgcCategoryList?.map((item, index) => ({
            link: `/videos/${item.path}`,
            label: item.label,
            className: index + 1 > 6 ? 'tw-hidden xl:tw-block' : '',
          }))}
          more="/video/groups"
          renderSlider={renderSlider}
          narrowScreenItemSize={6}
          wideScreenItemSize={10}
          swiperConfig={{
            slidesPerGroup: 3,
            slidesPerView: 3,
            spaceBetween: 12,
            slidesPerColumn: 2,
            slidesPerColumnFill: 'row',
            onSlideChange: () => {
              sendTeaCommEvent('clk_event', {
                page_id: 'page_main_new',
                event_id: 'video_module_change',
                module_id: 'video_module',
              })
            },
            breakpoints: {
              1920: {
                slidesPerView: 4,
                slidesPerGroup: 4,
                slidesPerColumn: 2,
              },
            },
          }}
          cols={cols}
          rows={rows}
          slideClass="tw-w-100/3 2xl:tw-w-2.5"
        />
        {dealeradBannerData && (
          <BannerAdWithSource
            sourceDataWithAd={dealeradBannerData}
            hideCloseIcon
            useSendEvent
            tea={{
              page_id: 'page_main_new',
            }}
          />
        )}
      </div>
      <div
        className="tw-col-span-10 2xl:tw-col-span-8"
        data-log-view-config={JSON.stringify({
          repeated: true,
        })}
        data-log-view={JSON.stringify({
          event: 'show_event',
          params: {
            page_id: 'page_main_new',
            event_id: 'common_conponent_module',
            module_id: 'video_rank_module',
          },
        })}
      >
        {dealeradInfo?.[AD_RIT.rit_dealer_ad_video_rank_top] && (
          <AdTextLink
            sourceData={dealeradInfo?.[AD_RIT.rit_dealer_ad_video_rank_top]}
            className="tw-mt-46 tw-mb-16"
            teaParams={{
              page_id: 'page_main_new',
              tab_name: '视频',
            }}
          />
        )}
        <FloorTabTitle
          title="视频排行榜"
          onTitleClick={() => {
            sendTeaCommEvent('clk_event', {
              page_id: 'page_main_new',
              event_id: 'video_rank_module_title',
              module_id: 'video_rank_module',
            })
          }}
        />
        <CommonTopTextCard
          teaParams={{
            page_id: 'page_main_new',
            event_id: 'video_rank_module_item',
            module_id: 'video_rank_module',
          }}
          list={videoPGCRankData?.map((item) => ({
            link: getContentJumpUrl(item.group_id, item.article_type),
            id: item.group_id,
            title: item.title,
            viewCount: item.count,
          }))}
        />
      </div>
      <style jsx>
        {`
          :global(.fix-swiper-mutil-row-mt-16 .swiper-slide) {
            margin-top: 0;
          }
        `}
      </style>
    </div>
  )
}

export default HomeVideo
